import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

export enum MaterialResourcesTab {
  Objects = 'objects',
  Controls = 'controls',
  Forms = 'forms',
  Properties = 'properties',
}

interface ITabObject {
  title: string
  page: MaterialResourcesTab
}

interface IProps {
  activeTab: MaterialResourcesTab
  onTabClick: (tab: MaterialResourcesTab) => void
}

function MaterialResourcesSetupTabs({ activeTab, onTabClick }: IProps) {
  const tabObjects: ITabObject[] = [
    { title: 'Objects', page: MaterialResourcesTab.Objects },
    { title: 'Controls', page: MaterialResourcesTab.Controls },
    { title: 'Forms', page: MaterialResourcesTab.Forms },
    { title: 'Properties', page: MaterialResourcesTab.Properties },
  ]

  return (
    <div className="tw:flex tw:items-center tw:h-[50px] tw:min-h-[50px] tw:max-h-[50px] tw:justify-start tw:relative tw:select-none">
      {tabObjects.map(({ title, page }) => {
        const isActive = page === activeTab
        return (
          <div
            key={page}
            className={classList({
              'tw:flex tw:items-center tw:justify-center tw:cursor-pointer tw:flex-none tw:h-full tw:max-w-[200px] tw:leading-5 tw:border-0 tw:border-b tw:border-solid': true,
              'tw:border-border tw:text-muted-foreground hover:tw:bg-muted active:tw:bg-muted':
                !isActive,
              'tw:text-primary tw:border-primary tw:border-b-2 hover:tw:bg-primary/10 active:tw:bg-primary/15':
                isActive,
            })}
            onClick={() => onTabClick(page)}
          >
            <span className="tw:px-5 tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis">
              {title}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default observer(MaterialResourcesSetupTabs)
